import {captureException} from "@sentry/react";

export default function fetchReducer(state, action) {
    const {data = null, rawResponse = null} = action?.payload ?? {};

    switch (action.type) {
        case 'FETCH_INIT': {
            return {
                ...state,
                isLoading: true,
                isError: false,
                isFinished: false,
                errorData: null,
                token: null,
            };
        }

        case 'FETCH_SUCCESS': {
            return {
                ...state,
                isLoading: false,
                isError: false,
                isFinished: true,
                data,
                errorData: null,
                rawResponse,
                ...(data?.token && {token: data.token}),
            };
        }

        case 'FETCH_FAILURE': {
            return {
                ...state,
                isLoading: false,
                isError: true,
                isFinished: true,
                data: null,
                rawResponse,
                ...(data && {errorData: data}),
            };
        }

        default:
            const err = new Error(`No action type ${action.type} found in fetchReducer`);
            captureException(err);
            throw err;
    }
};
